import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import DirectReportSelect from '../../../../components/DirectReportSelect/DirectReportSelect';
import { getDirectReports } from '../_api';
import Alert from '@mui/material/Alert';
import DirectReportsSelections from '../../../../components/DirectReportSelect/components/DirectReportsSelections';
import { nanoid } from 'nanoid';
import ReviewInformation from './steps/ReviewInformation/ReviewInformation';
import SubmissionSummary from './steps/SubmissionSummary/SubmissionSummary';
import { submitValidations } from '../_api';
import Spinner from '../../../../../../components/UI/Spinner/Spinner';
import { PAGE_ICONS, PAGE_ROUTES } from '../../../../_const';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import HomeIcon from '@mui/icons-material/Home';

import {
	fetchBasicDelegatedStaffList,
	fetchBasicStaffList,
} from 'pages/AnnualUserAccessReview/_api';
import { processStaffDataForTable } from 'pages/AnnualUserAccessReview/_util';
const steps = [
	'Select Direct Reports',
	'Review Information',
	'Submission Summary',
];
const RenewNonEmployeeAccessStepper = ({
	formik,
	currentUser,
	loggedInUser,
	targetUser,
	messages = [],
	initialStep = 0,
}) => {
	const [activeStep, setActiveStep] = useState(initialStep);
	const [isLoading, setIsLoading] = useState(false);
	const [directReports, setDirectReports] = useState([]);
	const [disableSubmit, setDisableSubmit] = useState(false);
	const [universalRenewalDate, setUniversalRenewalDate] = useState();
	const history = useHistory();

	useEffect(() => {
		setIsLoading(true);
		let impersonationID = currentUser.NetworkID;
		getDirectReports({
			upn: loggedInUser.UPN,
			impersonationId: impersonationID,
		}).then(data => {
			setDirectReports(
				data?.data?.payload?.staff
					.filter(staffMember => staffMember.type === 'nonEmployee')
					.sort((a, b) => {
						if (a.lastName < b.lastName) {
							return -1;
						} else {
							return 1;
						}
					}),
			);

			setIsLoading(false);
		});
	}, [currentUser, loggedInUser]);

	const handleNext = () => {
		if (
			Object.keys(formik.errors).length === 0 &&
			formik.values.staffMembersForReview
		) {
			setActiveStep(prevActiveStep => prevActiveStep + 1);
		}
	};

	const handleBack = () => {
		setActiveStep(prevActiveStep => prevActiveStep - 1);
	};

	const handleReset = () => {
		//reset formik
		formik.setFieldValue('staffMembersForReview', []);
		formik.setTouched({
			...formik.touched,
			staffMembersForReview: false,
		});
		// //reset page back to initial step
		// setActiveStep(0);
		setActiveStep(0);

		//refresh direct reports options
		setIsLoading(true);
		let impersonationID = currentUser.NetworkID;
		getDirectReports({
			upn: loggedInUser.UPN,
			impersonationId: impersonationID,
		}).then(data => {
			setDirectReports(
				data?.data?.payload?.staff
					.filter(staffMember => staffMember.type === 'nonEmployee')
					.sort((a, b) => {
						if (a.lastName < b.lastName) {
							return -1;
						} else {
							return 1;
						}
					}),
			);

			setIsLoading(false);
		});
	};

	const selectAllExpired = () => {
		let updatedDirectReports = directReports.filter(
			staffMember => !staffMember.isExpired
		);

		let updatedSelected = directReports.filter(staffMember => {
			return staffMember.isExpired;
		});

		if (formik) {
			formik.setFieldValue('staffMembersForReview', updatedSelected);
		}

		setDirectReports(updatedDirectReports);

		formik.setFieldValue('staffMembersForReview', [...updatedSelected]);
		formik.setTouched({
			...formik.touched,
			staffMembersForReview: true,
		});
	};
	const SelectionControls = () => {
		return (
			<>
				<Button
					onClick={() => selectAllExpired()}
					sx={{ marginBottom: '5px' }}
					variant='contained'
				>
					Select All Expired
				</Button>
			</>
		);
	};

	const [sStaff, setStaff] = useState([]);
	useEffect(() => {
		let active = true;

		async function fetchApi() {
			//fetch the base job category info
			const response = await fetchBasicStaffList(targetUser.ID);
			const response2 = await fetchBasicDelegatedStaffList(targetUser.ID);
			const allValues = [...response.values, ...response2.values];
			const data = processStaffDataForTable(allValues);
			//set the state
			setStaff(data);
			setIsLoading(false);
		}

		if (active && targetUser.ID) {
			fetchApi();
		}

		return () => {
			active = false;
		};
	}, [targetUser]);

	const renderActiveStep = () => {
		switch (activeStep) {
			case 0:
				return (
					<DirectReportSelect
						key={'step_' + activeStep}
						name='staffMembersForReview'
						formik={formik}
						directReports={sStaff.filter(
							dr => dr.accountCategoryName === 'NON_EMPLOYEE',
						)}
						headlineText='Select non employee staff members for review'
						nonEmployee={true}
						isReview={true}
					/>
				);
			case 1:
				return (
					<ReviewInformation
						formik={formik}
						setDisableSubmit={setDisableSubmit}
						universalRenewalDate={universalRenewalDate}
						setUniversalRenewalDate={setUniversalRenewalDate}
					/>
				);
			case 2:
				return (
					<SubmissionSummary
						staffMembers={formik.values.staffMembersForReview}
					/>
				);
			default:
				return (
					<div>
						Error Occurred... no defined step for step #{activeStep}
					</div>
				);
		}
	};

	const StepperControls = props => {
		switch (props.activeStep) {
			case 0:
				return (
					<>
						<Button
							disabled={activeStep === 0}
							onClick={handleBack}
							sx={{ mr: 2, mb: 5 }}
							variant='contained'
						>
							{'<<'} Back
						</Button>
						<Button
							onClick={() => {
								formik.setTouched({
									...formik.touched,
									staffMembersForReview: true,
								});
								handleNext();
							}}
							sx={{ mb: 5 }}
							variant='contained'
						>
							Review {'>>'}
						</Button>
					</>
				);
			case 1:
				return (
					<>
						<Button
							disabled={activeStep === 0}
							onClick={handleBack}
							sx={{ mr: 2, mb: 5 }}
							variant='contained'
						>
							{'<<'} Back
						</Button>
						<ValidateButton
							formik={formik}
							handleNext={handleNext}
							setIsLoading={setIsLoading}
							isLoading={isLoading}
							disabled={disableSubmit}
							universalRenewalDate={universalRenewalDate}
						/>
					</>
				);
			default:
				return (
					<>
						<Button
							variant='contained'
							startIcon={<PAGE_ICONS.HOME />}
							onClick={() => history.push(PAGE_ROUTES.HOME)}
							sx={{ mr: 2, mb: 5 }}
						>
							Back to User Access Review Home Page
						</Button>
						<Button
							variant='contained'
							startIcon={<HomeIcon />}
							onClick={() => history.push('/index.html')}
							sx={{ mr: 2, mb: 5 }}
						>
							Back to IMS Home Page
						</Button>
					</>
				);
		}
	};

	return (
		<Box sx={{ width: '100%' }}>
			<>
				{messages.map(({ type, message }) => {
					return <Alert severity={type}>{message}</Alert>;
				})}
			</>
			<Stepper activeStep={activeStep}>
				{steps.map(label => {
					const stepProps = {};
					const labelProps = {};
					return (
						<Step key={label} {...stepProps}>
							<StepLabel {...labelProps}>{label}</StepLabel>
						</Step>
					);
				})}
			</Stepper>

			{activeStep === steps.length ? (
				<>
					<Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
						<Box sx={{ flex: '1 1 auto' }} />
						<Button onClick={handleReset}>Reset</Button>
					</Box>
				</>
			) : (
				<>
					<Box sx={{ mt: 3 }}>
						{Object.keys(formik.errors).length > 0 &&
						Object.keys(formik.touched).length > 0 ? (
							<Alert severity='error'>
								<ul>
									{Object.keys(formik.errors).map(error => {
										return (
											<li key={nanoid()}>
												{formik.errors[error]}
											</li>
										);
									})}
								</ul>
							</Alert>
						) : null}
						<DirectReportsSelections
							formik={formik}
							selected={formik.values.staffMembersForReview}
							setSelected={selections =>
								formik.setFieldValue('staffMembersForReview', [
									...selections,
								])
							}
							directReports={directReports}
							setDirectReports={setDirectReports}
						/>
						{renderActiveStep()}
					</Box>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'row',
							pt: 2,
							justifyContent: 'center',
						}}
					>
						{isLoading ? (
							<Spinner />
						) : (
							<>
								<StepperControls activeStep={activeStep} />
							</>
						)}
					</Box>
				</>
			)}
		</Box>
	);
};

export default RenewNonEmployeeAccessStepper;

//private
const ValidateButton = ({
	formik,
	handleNext,
	setIsLoading,
	disabled,
	universalRenewalDate,
}) => {
	const [error, setError] = useState(null);

	const confirmValidations = () => {
		submitValidations(
			formik.values.staffMembersForReview,
			formik.values.currentUser,
			universalRenewalDate,
		)
			.then(response => {
				if (response.data.payload !== true) {
					setError(response.error);
				} else {
					handleNext();
				}
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	return (
		<>
			<Button
				onClick={() => {
					formik.setTouched({
						...formik.touched,
						staffMembersForReview: true,
					});
					setIsLoading(true);
					confirmValidations();
				}}
				sx={{ mb: 5 }}
				variant='contained'
				disabled={disabled}
			>
				Validate {'>>'}
			</Button>
			{error ? <Alert severity='error'>{error}</Alert> : null}
		</>
	);
};
